import React, {useContext, useEffect} from 'react';
import { observer } from "mobx-react-lite";
import { Context } from "../../index";

const PagesPolls = observer(() => {
    const { poolStore } = useContext(Context);

    const total = poolStore?.totalCount || 0;
    const limit = poolStore?.pollLimit > 0 ? poolStore.pollLimit : 48;
    const pageCount = Math.ceil(total / limit);

    const pages = [];

    if (total !== 0 && pageCount > 0) {
        for (let i = 0; i < pageCount; i++) {
            pages.push(i + 1);
        }
    } else {
        pages.push(0);
    }

    useEffect(() => {
        poolStore.setPollPage(1);
    }, [limit]); // следим за изменением лимита

    return (
        <nav aria-label="Page navigation" className="mt-3">
            <ul className="pagination pagination-sm">
                {pages.map((page) => (
                    <li
                        key={page}
                        className={`page-item ${poolStore.page === page ? 'active' : ''}`}
                        onClick={() => poolStore.setPollPage(page)}
                        style={{cursor: 'pointer'}}
                    >
                        <span
                            className={`page-link ${poolStore.pollPage === page ? 'bg-success text-white border-success' : 'text-success'}`}
                        >
                            {page}
                        </span>
                    </li>
                ))}
            </ul>

        </nav>

    );
});

export default PagesPolls;
